import { Module } from '@nu-art/ts-common';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_OnScrollBarUpdate = new ThunderDispatcher('__onScrollBarUpdate');
class ModuleFE_ScrollBar_Class extends Module {
    updateScrollBar = (scrollableRef) => {
        dispatch_OnScrollBarUpdate.dispatchUI(scrollableRef);
    };
}
export const ModuleFE_ScrollBar = new ModuleFE_ScrollBar_Class();
//# sourceMappingURL=ModuleFE_ScrollBar.js.map